import BannerModal from './BannerModal';

export default BannerModal;
